'use strict';

(function initializeAdventureRecentAdapter(root) {
    const app = root.dndNextLevel;
    const state = app.adventureState;
    const TYPE = 'adventure';
    const RESTORE_KEY = 'dnd-next-level:adventure:restore:v1';

    const adapter = {
        type: TYPE,
        route: '/adventure',
        capture(source) {
            const saved = state.validate(source?.saved) ? source.saved : source;
            return state.validate(saved) ? {version: 1, saved: state.clone(saved)} : null;
        },
        validate(payload) {
            return payload?.version === 1 && state.validate(payload.saved);
        },
        preview(payload) {
            if (!adapter.validate(payload)) throw new Error('Invalid Adventure recent creation');
            const result = payload.saved.result;
            return {
                title: 'Adventure outline',
                description: [result.settingLabel, result.tierLabel].filter(Boolean).join(' · '),
            };
        },
        restore(payload) {
            if (!adapter.validate(payload)) throw new Error('Invalid Adventure recent creation');
            root.sessionStorage.setItem(RESTORE_KEY, JSON.stringify(payload));
            root.location.assign(adapter.route);
            return payload.saved;
        },
    };

    const readShared = storage => app.recentCreationStore.create(storage).read()
        .filter(entry => entry.type === TYPE);

    const saveCurrent = (saved, storage = root.localStorage, pinned = false, now = Date.now()) => {
        const payload = adapter.capture(saved);
        if (!payload || !app.recentCreationStore) return null;
        const store = app.recentCreationStore.create(storage);
        const previous = store.read().find(entry => entry.type === TYPE && entry.id === 'current');
        const entry = {
            id: 'current',
            type: TYPE,
            createdAt: previous?.createdAt ?? now,
            updatedAt: now,
            pinned: pinned || previous?.pinned || false,
            payload,
        };
        store.save(entry);
        app.recentCreations?.instance?.render();
        return entry;
    };

    const consumeRestore = (storage = root.localStorage, sessionStorage = root.sessionStorage) => {
        const raw = sessionStorage.getItem(RESTORE_KEY);
        sessionStorage.removeItem(RESTORE_KEY);
        if (!raw) return null;
        try {
            const payload = JSON.parse(raw);
            if (!adapter.validate(payload) || !state.persist(storage, payload.saved)) return null;
            return payload.saved;
        } catch (_error) {
            return null;
        }
    };

    app.adventureRecentAdapter = {
        adapter,
        saveCurrent,
        readShared,
        consumeRestore,
        RESTORE_KEY,
        STORAGE_KEY: state.storageKey(),
    };
    app.recentCreationAdapters?.registry?.register(adapter);
})(window);
